module.exports = __webpack_public_path__ + "img/SIKH TURBAN PURPLE.4cb970a.svg";